const automationRoutes = {
  path: "automation",
  children: [
    {
      index: true,
      lazy: async () => {
        const mod = await import("views/Admin/Automation/index");
        const Automation = mod.default;
        return { Component: Automation };
      },
    },
    {
      path: ":id",
      lazy: async () => {
        const mod = await import("views/Admin/Automation/automation-analytics");
        const AutomationAnalytics = mod.default;
        return { Component: AutomationAnalytics };
      },
    },
  ],
};

export default automationRoutes;
